export const resolveSelectedAccounts = (isStandaloneMode, contextAccounts, selectedSearchAccounts, internalSelectedAccounts, propSelectedAccounts) => {
    if (!isStandaloneMode) {
        return propSelectedAccounts || [];
    }
    if (contextAccounts.length > 0) {
        return contextAccounts.map((account) => {
            const result = {
                id: account.Id,
                name: account.AccountName,
                type: account.AccountType,
                label: `${account.AccountName} (${account.AccountType})`,
            };
            if (account.TimeZone) {
                result.timeZone = account.TimeZone;
            }
            return result;
        });
    }
    if (selectedSearchAccounts.length > 0) {
        return selectedSearchAccounts.map((account) => {
            const result = {
                id: account.Id,
                name: account.AccountName,
                type: account.AccountType,
                label: `${account.AccountName} (${account.AccountType})`,
            };
            if (account.TimeZone) {
                result.timeZone = account.TimeZone;
            }
            return result;
        });
    }
    return internalSelectedAccounts;
};
export const resolveSelectedUsers = (isStandaloneMode, contextUsers, internalSelectedUsers, propSelectedUsers) => {
    if (!isStandaloneMode) {
        return propSelectedUsers || [];
    }
    if (contextUsers.length > 0) {
        return contextUsers.map((user) => ({
            id: user.Id,
            displayName: user.DisplayName,
            firstName: user.FirstName,
            lastName: user.LastName,
            label: user.DisplayName,
        }));
    }
    return internalSelectedUsers;
};
export const resolveDateRange = (isStandaloneMode, internalDateRange, propStartDate, propEndDate) => {
    if (!isStandaloneMode && propStartDate && propEndDate) {
        return { startDate: propStartDate, endDate: propEndDate };
    }
    return internalDateRange;
};
export const generateAggregateTitle = (selectedUsers, selectedAccounts) => {
    if (selectedUsers.length > 0 && selectedAccounts.length > 0) {
        return "All Selected Accounts & Users";
    }
    if (selectedUsers.length > 0) {
        return "All Selected Users";
    }
    return "All Selected Accounts";
};
//# sourceMappingURL=selectionUtils.js.map